import { render, staticRenderFns } from "./CommentsSuccessModal.vue?vue&type=template&id=62f99aea&scoped=true&"
import script from "./CommentsSuccessModal.vue?vue&type=script&lang=js&"
export * from "./CommentsSuccessModal.vue?vue&type=script&lang=js&"
import style0 from "./CommentsSuccessModal.vue?vue&type=style&index=0&id=62f99aea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f99aea",
  null
  
)

export default component.exports